module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-content pt-4"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "table-orders"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.reclamos), function(data) {
    return _c('tr', {
      key: data
    }, [_c('td', {
      staticStyle: {
        "max-width": "200px"
      }
    }, [_vm._v(_vm._s(data.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "min-width": "180px"
      }
    }, [_vm._v(_vm._s(data.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.store_id === 1 ? 'SENDI' : 'ENVIOS USA'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.created_at))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "link",
      attrs: {
        "to": {
          name: 'ReclamoDetails',
          params: {
            id: data.id
          }
        }
      }
    }, [_vm._v("Ver más")])], 1)])
  }), 0)])])]), _vm._v(" "), (_vm.is_loading == false) ? _c('pagination', {
    attrs: {
      "pagination": _vm.pagination
    },
    on: {
      "changePagination": _vm.getPurchaseOrdersByPage
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row d-flex justify-content-between px-3"
  }, [_c('h2', {
    staticClass: "form-title-principal form-title"
  }, [_vm._v("Reclamaciones")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "max-width": "200px"
    }
  }, [_vm._v("Nombre")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "180px"
    }
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Tienda")]), _vm._v(" "), _c('th', [_vm._v("Fecha")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-137ec27c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Reclamaciones.vue
// module id = 1852
// module chunks = 1